import { React, useEffect, useState } from "react";
import Section2_product from "../products";
import { useMenus } from "../../../../hooks/apis/menu";

function Section2_menu() {
  const { data, isLoading, error } = useMenus();
  const [menus, setMenu] = useState([]);
  const [foodId, setFoodId] = useState(6);
  const [shopId, setShop] = useState(1);

  //loading state
  //   const [loading, setLoading] = useState(false);

  //   const getMenu = async () => {
  //     setLoading(true);
  //     const response = await fetch("https://panel.baghban.restaurant/api/menus");
  //     const menu = await response.json();
  //     console.log(menu);
  //     setMenu(menu);
  //     setLoading(false);
  //     if (shopId == 1) {
  //       setFoodId(6);
  //     } else if (shopId == 2) {
  //       setFoodId(3);
  //     }
  //   };

  useEffect(() => {
    if (data) {
      setMenu(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (shopId === 1) {
      setFoodId(6);
    } else if (shopId === 2) {
      setFoodId(3);
    }
  }, [shopId]);

  return (
    <>
      <div className="food-menu">
        <div className="menu-kind">
          <a
            onClick={() => {
              setShop(1);
            }}
            className={shopId == 1 ? "active" : ""}
          >
            منو رستوران{" "}
          </a>
          <a
            onClick={() => {
              setShop(2);
            }}
            className={shopId == 2 ? "active" : ""}
          >
            منو کافی شاپ
          </a>
        </div>
        <div className="food-kind">
          <div className={isLoading ? "active loading" : "loading"}>
            <img
              src={process.env.PUBLIC_URL + "/images/loading.svg"}
              className="img-fluid"
            />
          </div>
          <ul>
            <li key={0}>
              <img
                src={process.env.PUBLIC_URL + "/images/all-menu.svg"}
                alt=""
                title=""
                className="img-fluid"
              />
              <p className="title">دسته بندی ها</p>
            </li>
            {menus.map((menu) => {
              if (menu.shop_id == shopId) {
                {
                  return (
                    <li
                      onClick={() => {
                        setFoodId(menu.id);
                      }}
                      data-id={menu.id}
                      key={menu.id}
                      className={menu.id == foodId ? "active" : ""}
                    >
                      <img
                        src={menu.photo}
                        alt={menu.title}
                        title={menu.title}
                        className="img-fluid"
                      />
                      <p className="title">{menu.title}</p>
                    </li>
                  );
                }
              }
            })}
          </ul>
        </div>
      </div>

      <Section2_product id={foodId} />
    </>
  );
}

export default Section2_menu;
